import { render } from "./GamesPop1.vue?vue&type=template&id=2587c853"
import script from "./GamesPop1.vue?vue&type=script&lang=js"
export * from "./GamesPop1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__